import {SprayRecord} from "./spray-record";
import * as _ from 'lodash';

export class Location {

  id: string;
  application_rate: number;
  block: string;
  bloom_date: string;
  emitter_flow: number;
  emitter_spacing_between_rows: number;
  emitter_spacing_in_row: number;
  emitters_per_acre: number;
  farm: string;
  green_tip_date: string;
  pct_spurs_flowering: number;
  orchard_age: string;
  owner: string;
  spacing_between_rows: number;
  spacing_in_row: number;
  trees_per_acre: number;
  tree_row_volume: number;
  tree_height: number;
  tree_width: number;
  variety: string;
  water_holding_capacity: number;
  weather_station_title_dummy: string;
  year: number;

  spray_records: Array<SprayRecord>;
  weather_station: any;   // {id: "krme", title: "Griffiss"}

  constructor(private fields: any) {
    this.fields = fields;

    // Quick and dirty extend/assign fields to this model
    for (let f in fields) {
      this[f] = fields[f];
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/location.ts